<bx-card>
  <div class="gap-3xl p-3xl flex w-full content-start">
    <div class="relative flex h-16 w-16 items-start">
      <img [ngSrc]="imagePath()" fill alt="Thing image" (error)="imageFailed.set(true)" />
    </div>

    <div class="gap-4xl flex flex-1">
      <bxi-attributes-panel [data]="basicInformation()"></bxi-attributes-panel>

      @if (location().attributes.length) {
        <bxi-attributes-panel [data]="location()"></bxi-attributes-panel>
      }

      @if (settings().attributes.length) {
        <bxi-attributes-panel [data]="settings()"></bxi-attributes-panel>
      }

      @if (meterInfo().attributes.length) {
        <bxi-attributes-panel [data]="meterInfo()"></bxi-attributes-panel>
      }

      <div class="gap-4xl flex flex-1 flex-col">
        <bxi-device-tags></bxi-device-tags>

        @if (installationPoint().attributes.length) {
          <bxi-attributes-panel [data]="installationPoint()"></bxi-attributes-panel>
        }
      </div>
    </div>
  </div>
</bx-card>
